// src/pages/Character.tsx
import React, { FC } from 'react';

export const Inventory: FC = () => <div>Inventory page</div>;

export default Inventory;
